
import React from 'react';
import { useParams } from 'react-router-dom';
import { useEventDetails } from './event-details/hooks/useEventDetails';
import { EventDetailsLayout } from './event-details/components/EventDetailsLayout';
import { EventDetailsLoading } from './event-details/components/EventDetailsLoading';
import { EventNotFound } from './event-details/components/EventNotFound';

const EventDetailsPage = () => {
  const { eventId } = useParams();
  const {
    event,
    loading,
    isEditing,
    viewMode,
    hasUnsavedChanges,
    editingField,
    handleBack,
    handleEditToggle,
    handleViewModeChange,
    handleInputChange,
    handleSaveChanges,
    handleCancelChanges,
    handleEditField,
    handleDeleteAndNavigate
  } = useEventDetails();

  if (loading) {
    return <EventDetailsLoading />;
  }

  if (!event) {
    return <EventNotFound />;
  }

  return (
    <EventDetailsLayout
      event={event}
      isEditing={isEditing}
      viewMode={viewMode}
      onBack={handleBack}
      onEditToggle={handleEditToggle}
      onViewModeChange={handleViewModeChange}
      onFieldChange={handleInputChange}
      hasUnsavedChanges={hasUnsavedChanges}
      onSaveChanges={handleSaveChanges}
      onCancelChanges={handleCancelChanges}
      onEditField={handleEditField}
      editingField={editingField}
      onDelete={handleDeleteAndNavigate}
    />
  );
};

export default EventDetailsPage;
